import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import QuestionPrompt from '../QuestionPrompt';
import ABConceptAttributes from './AbConceptAttributes';
import QuestionMedia from '../QuestionMedia';
import QuestionBody from '../QuestionBody';
import Answers from '../Answers';

import useSetup from './hooks/useSetup';

export default function AnswersWrapper({
  question,
  isDisplaySamePage = false,
  questionIndex = 0,
  showDivider = false,
}) {
  const { groups } = Pollfish.survey;
  const {
    mediaAttributes,
    visibleAnswers,
    visibleScorepoints,
    wrapperClassName,
  } = useSetup(question);

  return (
    <div
      id={question.id}
      className={classNames('js-question', {
        'same-page-question-wrapper': isDisplaySamePage,
      })}
      data-ref-id={question.refId || ''}
      data-question-display-same-page={isDisplaySamePage}
      data-same-page-validated-once={false}
      data-same-page-is-valid-answers={false}
    >
      {isDisplaySamePage && (
        <Fragment>
          <QuestionPrompt
            question={question}
            showText={isDisplaySamePage}
            showPrompt={isDisplaySamePage}
            showProgressBar={false}
            showProgressBarQuestionIndex={false}
            questionIndex={questionIndex}
            showPromptQuestionIndex
          />
          <p className="validation-message"></p>
        </Fragment>
      )}
      <div className={wrapperClassName}>
        <ABConceptAttributes groups={groups} question={question} />
        <QuestionMedia {...mediaAttributes} />
        <QuestionBody
          question={question}
          answers={visibleAnswers}
          scorepoints={visibleScorepoints}
        />
        <Answers question={question} answers={visibleAnswers} />
        {showDivider && (
          <div className="divider same-page-question-divider container-max-width"></div>
        )}
      </div>
    </div>
  );
}

AnswersWrapper.propTypes = {
  question: PropTypes.object,
  isDisplaySamePage: PropTypes.bool,
  questionIndex: PropTypes.number,
  showDivider: PropTypes.bool,
};
